import { useEffect, useState } from "react";
import DataContext from "./data-context";
import useGetInitialData from "../hooks/_REST API/GET/use-get-initial-data";

const langData = [
  {
    id: 0,
    lang: "hr",
    market: "oglasnik",
  },
  {
    id: 1,
    lang: "de",
    market: "anzeigenmarkt",
  },
];

export default function DataProvider(props) {
  const [categories, setCategories] = useState(-1);

  const { pageData, galleries, references, getInitialData } =
    useGetInitialData();

  const [lang, setLang] = useState(
    window.location.hash.slice(2, 4) === "hr" ? langData[0] : langData[1]
  );

  const [hash, setHash] = useState(window.location.hash || "hr");
  window.addEventListener("hashchange", () => setHash(window.location.hash));

  /* CHANGE LANG ID */
  useEffect(() => {
    const lng = window.location.hash.slice(2, 4) || "hr";

    getInitialData(lng);

    if (lng !== lang.lang) {
      setLang(lng === "hr" ? langData[0] : langData[1]);
    }
  }, [hash]);

  useEffect(() => {
    if (galleries !== -1 && galleries !== -2 && galleries.length > 0) {
      setCategories(galleries.filter((e) => e.categories[0].term_id === 61));
    }
  }, [galleries]);

  const dataContext = {
    pageData,
    categories,
    galleries,
    references,
    lang,
    setHash,
  };

  return (
    <DataContext.Provider value={dataContext}>
      {props.children}
    </DataContext.Provider>
  );
}
